import { useContext } from "react";
import { useQuery } from "react-query";
import AppContext from "../appContext";
import * as api from "../services";
const initProjects = [];
const projectModel = (project) => {
  return {
    ...project,
    // context info
    id: project?.id ?? -1,
    firstName: project?.firstName ?? "",
    lastName: project?.lastName ?? "",
    code: project?.code ?? "",
  };
};

export default function useProjects() {
  const {
    app: { sessionId },
  } = useContext(AppContext);
  const { data, isLoading, isError, refetch } = useQuery(
    ["projects", sessionId],
    () =>
      api.getProjects({ sessionId }).then((data) => {
        if (Array.isArray(data?.projects)) {
          return data.projects.map((project) => projectModel(project));
        }
        return initProjects;
      }),
    {
      placeholderData: () => initProjects,
    }
  );
  return {
    projects: data, // all contexts
    isLoading,
    isError,
    refetchProjects: refetch,
  };
}
